var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.appTransition}},[_c(_vm.currentComponent,{tag:"is-component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }